"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviorDistrictCodeCreateDto = void 0;
const class_validator_1 = require("class-validator");
const mappable_base_1 = require("../../mappable.base");
const class_transformer_1 = require("class-transformer");
const boolean_transform_1 = require("../../constants/boolean.transform");
class BehaviorDistrictCodeCreateDto extends mappable_base_1.MappableBase {
    constructor(behaviorDistrictCodeOptions) {
        super();
        if (!behaviorDistrictCodeOptions)
            return;
        Object.assign(this, behaviorDistrictCodeOptions);
    }
    getFields() {
        return [
            'code',
            'description',
            'passMessage',
            'printPass',
            'active',
            'fastTrack',
            'behaviorCodeTypeId',
            'schoolId',
            'externalReferenceCode'
        ];
    }
    code;
    description;
    passMessage;
    printPass;
    fastTrack;
    active;
    behaviorCodeTypeId;
    externalReferenceCode;
    schoolGroupId;
}
exports.BehaviorDistrictCodeCreateDto = BehaviorDistrictCodeCreateDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(50),
    __metadata("design:type", String)
], BehaviorDistrictCodeCreateDto.prototype, "code", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(250),
    __metadata("design:type", String)
], BehaviorDistrictCodeCreateDto.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(512),
    __metadata("design:type", String)
], BehaviorDistrictCodeCreateDto.prototype, "passMessage", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    __metadata("design:type", Boolean)
], BehaviorDistrictCodeCreateDto.prototype, "printPass", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    __metadata("design:type", Boolean)
], BehaviorDistrictCodeCreateDto.prototype, "fastTrack", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    __metadata("design:type", Boolean)
], BehaviorDistrictCodeCreateDto.prototype, "active", void 0);
__decorate([
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], BehaviorDistrictCodeCreateDto.prototype, "behaviorCodeTypeId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(50),
    __metadata("design:type", String)
], BehaviorDistrictCodeCreateDto.prototype, "externalReferenceCode", void 0);
__decorate([
    (0, class_validator_1.Min)(1),
    __metadata("design:type", Number)
], BehaviorDistrictCodeCreateDto.prototype, "schoolGroupId", void 0);
